import { ObservableArray, View } from "binder"
import { PersonnelAccessManipulationViewModel, SinglePersonnel } from "./personnelAccessManipulation-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class PersonnelAccessManipulationView extends View<PersonnelAccessManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-139EB996-3C04-4E50-AA13-27FA253D6C0C"
    }
    loadHtml(): string {
        let element = require('./personnelAccessManipulation.html').default;
        let style = require('./personnelAccessManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set personnel(v: ObservableArray<SinglePersonnel>) { this._personnel = v; } public get personnel(): ObservableArray<SinglePersonnel> { return this._personnel;} private _personnel: ObservableArray<SinglePersonnel>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    save(){
        this.dataContext.save();
    }
}
